export enum Errors {
  ErrADD = 'Unable to add a todo',
  ErrDEL = 'Unable to delete a todo',
  ErrUPD = 'Unable to update a todo',
  ErrBlankTitle = 'Title can\'t be empty',
  ErrGET = 'Can\'t download from server',
  ErrNone = '',
}
